export const removeNonNumeric = (num: string | string) =>
  num.toString().replace(/[^0-9]/g, "");

export const addThousandSeparator = (num: number | string, separator = ".") =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
